module.exports = __webpack_public_path__ + "img/nodtransferdark.png.ee07143b.webp";